import { render, staticRenderFns } from "./AssessmentTaskModal.vue?vue&type=template&id=9cf3bad6&"
import script from "./AssessmentTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports